// Google Analytics 4, gated on REACT_APP_GA_MEASUREMENT_ID. Without the env
// var nothing is injected and no data is collected. The SPA uses client-side
// routing, so page views are sent manually on route change (see
// usePageTracking) with automatic page_view disabled.

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initAnalytics = (): void => {
  if (!measurementId || window.gtag) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  // send_page_view false — the SPA reports page views itself on route change
  window.gtag("config", measurementId, { send_page_view: false });
};

/** Send a page view for the given path. No-op when analytics is disabled. */
export const trackPageView = (path: string): void => {
  if (!measurementId || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
